import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "collection",
  "use": "collection-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"collection\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 1H2a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V2a1 1 0 00-1-1zM2 6V2h4v4H2zm0 4v4h4v-4H2zm4-1H2a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1zm4-7v4h4V2h-4zm4-1h-4a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V2a1 1 0 00-1-1z\" /><path d=\"M12.5 9h-1v2.5H9v1h2.5V15h1v-2.5H15v-1h-2.5V9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol